export default __webpack_public_path__ + "7ac233c9397c9dd64fc495eeaacb300a.png";